module.exports = __webpack_public_path__ + "img/wodegerenxinxiB.dcb796a8.png";